import _merge from 'lodash/merge';
import config from '@bedrock-rdk/config';
import { translate } from './utils';
import { dictionary, languages } from './customer/default.languages';

let bundle = { ...dictionary, languages };

export const setupI18NOverrides = overrides => {
  if (overrides) {
    bundle = _merge(bundle, overrides);
  }
};

export const destroy = () => {
  bundle = undefined;
};

export const t = translate(bundle, config.i18nNames);
